import { Certification } from '~/types/mcv/certification';
import { CERTIFICATES_OPTIONS, ISSUER_OPTIONS } from './constants';
import { CertFormValues } from './types';

export const transformCertToFormValue = (certString: string): CertFormValues => {
  const cert: Certification = JSON.parse(certString);

  // AI-parsed records may return null for fields the form requires.
  // Intentionally coerce null to safe defaults at the edit boundary.
  const certName = cert.certName
    ? CERTIFICATES_OPTIONS.find((c) => c.value === cert.certName) || {
        label: cert.certName,
        value: cert.certName,
      }
    : CERTIFICATES_OPTIONS[0];

  const issuer = cert.issuer
    ? ISSUER_OPTIONS.find((i) => i.value === cert.issuer) || {
        label: cert.issuer,
        value: cert.issuer,
      }
    : ISSUER_OPTIONS[0];

  return {
    activeFlag: cert.activeFlag ?? false,
    certName,
    certNum: cert.certNum ?? '',
    expiryDate: cert.expiryDate ?? '',
    id: cert.id,
    issueDate: cert.issueDate ?? '',
    issuer,
    validFlag: cert.validFlag ?? true,
    warnings: cert.warnings ?? {},
  };
};

export const transformCertsToFormValue = (certsString: string): CertFormValues[] => {
  const certs: Certification[] = JSON.parse(certsString);
  return certs.map((cert) => transformCertToFormValue(JSON.stringify(cert)));
};

export const transformFormValuesToCert = (formData: CertFormValues): string => {
  const isActive = formData.expiryDate ? new Date() < new Date(formData.expiryDate) : true;
  const transformedCert = {
    activeFlag: isActive,
    certName: formData.certName.label,
    certNum: formData.certNum || '',
    expiryDate: formData.expiryDate || null,
    id: formData.id,
    issueDate: formData.issueDate || null,
    issuer: formData.issuer?.label || '',
    validFlag: formData.validFlag,
    warnings: formData.warnings,
  };

  return JSON.stringify(transformedCert);
};

export const determineActiveStatus = (expiredDate: string): string => {
  const today = new Date();
  const expiryDate = new Date(expiredDate);
  const warningDate = new Date();
  warningDate.setDate(today.getDate() + 180);

  if (expiryDate < today) {
    return 'Expired';
  }

  if (expiryDate <= warningDate) {
    return 'Expiring Soon';
  }

  return 'Active';
};
